import { render, staticRenderFns } from "./QueryRedeemCodeDetailsPage.vue?vue&type=template&id=1c5d81ca&scoped=true"
import script from "./QueryRedeemCodeDetailsPage.vue?vue&type=script&lang=js"
export * from "./QueryRedeemCodeDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./QueryRedeemCodeDetailsPage.vue?vue&type=style&index=0&id=1c5d81ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d81ca",
  null
  
)

export default component.exports